import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDtjdYyDgaH71nykLEI193nzCKg2dalnKo",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "koubi-v2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "koubi-v2",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "koubi-v2.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "27504897052",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:27504897052:web:bcbc95524315b93e8e03d9",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-6CV89SH40R",
};

// Check if Firebase has already been initialized
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export Firebase instances and logEvent
export { firebaseConfig, app, analytics, logEvent };